import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => {
  const tableRowTransactionStyle = {
    cursor: 'default',
    fontStyle: 'italic',
    fontSize: '0.75rem',
    backgroundColor: theme.palette.baseColors.iceBlue.c25,
  };

  return {
    download: {
      maxWidth: 'fit-content',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      boxShadow: 'none',
    },
    container: {
      flex: 1,
      position: 'relative',
      height: 'calc(100vh - 300px)',
    },
    tableWrapper: {
      height: '100%',
      width: '100%',
      position: 'absolute',
      inset: 0,
    },
    table: {
      '&.MuiDataGrid-root': {
        marginBottom: theme.spacing(2),
        borderTopLeftRadius: 0,
      },
      '&.MuiDataGrid-root .MuiDataGrid-columnHeaderDraggableContainer .MuiDataGrid-columnHeaderTitle':
        {
          textOverflow: 'clip',
          whiteSpace: 'break-spaces',
          lineHeight: 1,
        },
      '&.MuiDataGrid-root .MuiDataGrid-row:hover': {
        backgroundColor: theme.palette.baseColors.iceBlue.c50,
      },
      '&.MuiDataGrid-root .MuiDataGrid-row.Mui-selected': {
        backgroundColor: theme.palette.baseColors.skyBlue.c25,
      },
      '&.MuiDataGrid-root .MuiDataGrid-overlay .MuiCircularProgress-root': {
        color: theme.palette.accentText.color,
      },
    },

    tableRowGroup: {
      cursor: 'pointer',
    },

    tableRowGroupExpanded: {
      cursor: 'pointer',
      color: 'black',
      backgroundColor: theme.palette.baseColors.iceBlue.c100,
    },

    tableRowTransaction: tableRowTransactionStyle,
    tableRowTransactionFirst: {
      ...tableRowTransactionStyle,
      boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.1)',
    },

    tableRowTransactionLast: {
      ...tableRowTransactionStyle,
      boxShadow: 'inset 0px -4px 4px rgba(0, 0, 0, 0.1)',
    },

    tableRowLoadMore: {
      ...tableRowTransactionStyle,
      boxShadow: 'inset 0px -4px 4px rgba(0, 0, 0, 0.1)',
    },
  };
});
